import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punelocalandouutstationcab() {



  const cardData = {
"keyword": "Pune Local and Outstation Cab",

"headingDescription":
  "Shivai Travels offers reliable Pune Local and Outstation Cab services designed to meet all your travel needs, whether within the city or to nearby and long-distance destinations. Our service is ideal for daily commuting, airport transfers, railway station pickups, business travel, family outings, sightseeing, and weekend trips. With professional drivers, clean and well-maintained air-conditioned vehicles, and transparent pricing with no hidden charges, we ensure a safe, comfortable, and stress-free travel experience. Our fleet includes sedans, SUVs, and premium cars suitable for individuals, families, and corporate travelers. With easy online booking, flexible travel packages, and 24/7 customer support, Shivai Travels provides dependable local and outstation cab services across Pune and beyond.",

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description":
      "Shaniwar Wada is a historic fort in Pune known for its Maratha heritage and architectural beauty. Local cab services make it easy for travelers to explore this iconic landmark and nearby attractions."
  },
  {
    "title": "Lonavala",
    "description":
      "Lonavala is a popular hill station near Pune famous for waterfalls, valleys, and scenic viewpoints. Outstation cab services from Pune provide a comfortable and quick getaway to this nature-filled destination."
  },
  {
    "title": "Aga Khan Palace",
    "description":
      "Aga Khan Palace is an important historical monument associated with India’s freedom struggle. Local cab services in Pune offer convenient access for sightseeing and cultural exploration."
  },
  {
    "title": "Mahabaleshwar",
    "description":
      "Mahabaleshwar is a beautiful hill station known for cool climate, strawberry farms, and viewpoints. Outstation cabs from Pune ensure a smooth and relaxing travel experience to this tourist destination."
  },
  {
    "title": "Sinhagad Fort",
    "description":
      "Sinhagad Fort is a famous trekking and historical site near Pune offering scenic mountain views. Local and outstation cab services provide easy access for adventure and sightseeing trips."
  },
  {
    "title": "Shirdi",
    "description":
      "Shirdi is a major pilgrimage destination dedicated to Sai Baba. Outstation cab service from Pune offers a comfortable and hassle-free spiritual journey."
  },
  {
    "title": "Koregaon Park",
    "description":
      "Koregaon Park is a premium locality in Pune known for cafes, restaurants, and nightlife. Local cab services provide smooth transportation for leisure and city travel."
  },
  {
    "title": "Nashik",
    "description":
      "Nashik is known for temples, vineyards, and religious significance. Outstation cab services from Pune make it easy to enjoy sightseeing and spiritual visits."
  },
  {
    "title": "Viman Nagar",
    "description":
      "Viman Nagar is a modern residential and commercial area near Pune Airport. Local cab services ensure convenient travel for business and airport transfers."
  },
  {
    "title": "Goa",
    "description":
      "Goa is a famous beach destination known for tourism, nightlife, and water sports. Outstation cab service from Pune offers a comfortable road trip for holiday travelers."
  }
],



services: [
  {
    name: "Pune Local and Outstation Cab",
    description: "Pune local and outstation cab service provides reliable transportation for city travel, airport transfers, and long-distance journeys from Pune. Comfortable vehicles with experienced drivers ensure smooth city and highway travel for families, tourists, and business travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Vehicles include sedans, SUVs, Innova Crysta, Ertiga, and premium taxis suitable for different travel needs. Flexible booking options allow convenient local and outstation cab reservations."
  },
  {
    name: "Local Cab Pune",
    description: "Local cab Pune service offers dependable transportation for daily travel, office commutes, shopping trips, and city sightseeing within Pune. Comfortable vehicles provide smooth city travel experience suitable for individuals, families, and tourists. Professional drivers ensure safe driving and punctual pickup services throughout Pune city. Pickup services are available from homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient local cab reservations."
  },
  {
    name: "Outstation Cab Pune",
    description: "Outstation cab Pune service provides reliable transportation for passengers traveling from Pune to nearby cities, tourist destinations, and pilgrimage locations. Vehicles are suitable for long-distance highway travel with spacious seating and luggage capacity. Professional drivers ensure safe journeys and timely pickup services throughout the trip. Pickup services are available across Pune including homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient outstation cab reservations."
  },
  {
    name: "City Taxi Pune",
    description: "City taxi Pune service offers comfortable transportation for local travel across Pune city with experienced drivers and well-maintained vehicles. Vehicles provide smooth city travel suitable for business trips, shopping, airport transfers, and tourism. Professional chauffeurs ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient city taxi reservations."
  },
  {
    name: "Pune Day Rental Cab",
    description: "Pune day rental cab service provides convenient transportation for passengers requiring full-day travel within Pune and nearby destinations. Comfortable vehicles ensure smooth city and highway travel suitable for business meetings, sightseeing, shopping trips, and family outings. Professional drivers ensure safe driving and reliable transportation services throughout the day. Pickup services are available from homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient day rental cab reservations."
  },
  {
    name: "Hourly Cab Pune",
    description: "Hourly cab Pune service offers flexible transportation for passengers needing taxis for a few hours within Pune city. Comfortable vehicles provide smooth city travel suitable for meetings, shopping, local sightseeing, and personal travel needs. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, offices, hotels, railway stations, and airports. Flexible booking options allow convenient hourly cab reservations."
  },
  {
    name: "Pune Intercity Cab",
    description: "Pune intercity cab service provides reliable transportation between Pune and nearby cities with comfortable vehicles and professional drivers. Vehicles are suitable for expressway and highway travel ensuring smooth and safe journeys for passengers. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Ideal for business travel, tourism, airport transfers, and family trips. Flexible booking options allow convenient intercity cab reservations."
  },
  {
    name: "Local Sightseeing Cab Pune",
    description: "Local sightseeing cab Pune service offers comfortable transportation for tourists and families exploring Pune city attractions and nearby destinations. Vehicles provide smooth city travel suitable for sightseeing tours, shopping visits, and local tourism activities. Professional chauffeurs ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient sightseeing cab reservations."
  },
  {
    name: "Outstation Travel Cab Pune",
    description: "Outstation travel cab Pune service provides dependable transportation for long-distance journeys from Pune to tourist destinations, business cities, and pilgrimage places. Comfortable vehicles ensure smooth highway travel with experienced drivers maintaining passenger safety and comfort. Pickup services are available across Pune including homes, offices, hotels, railway stations, and airports. Ideal for family trips, business travel, and tourism. Flexible booking options allow convenient outstation travel reservations."
  },
  {
    name: "Pune Cab Hire Local",
    description: "Pune cab hire local service offers convenient transportation for passengers traveling within Pune city for office work, shopping, tourism, and personal travel needs. Comfortable vehicles ensure smooth city travel with professional drivers providing safe and reliable transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow easy local cab hire reservations."
  },
  {
    name: "Pune Cab Hire Outstation",
    description: "Pune cab hire outstation service provides reliable transportation for passengers planning long-distance journeys from Pune to various destinations. Vehicles include sedans, SUVs, Innova Crysta, and premium taxis suitable for comfortable highway travel. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient outstation cab hire reservations."
  },
  {
    name: "Full Day Cab Pune",
    description: "Full day cab Pune service offers reliable transportation for passengers requiring taxis for an entire day within Pune and nearby locations. Comfortable vehicles ensure smooth city and highway travel suitable for sightseeing, business meetings, shopping trips, and family outings. Professional chauffeurs ensure safe driving and timely transportation services throughout the day. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Flexible booking options allow convenient full-day cab reservations."
  },
  {
    name: "Half Day Cab Pune",
    description: "Half day cab Pune service provides convenient transportation for passengers needing taxis for short-duration travel within Pune city. Comfortable vehicles ensure smooth city travel suitable for meetings, shopping, local sightseeing, and airport transfers. Professional drivers ensure safe journeys and punctual pickup services across Pune. Pickup services are available from homes, offices, hotels, railway stations, and airports. Flexible booking options allow convenient half-day cab reservations."
  },
  {
    name: "Flexible Cab Booking Pune",
    description: "Flexible cab booking Pune service offers customizable transportation options for local and outstation travel according to passenger schedules and travel requirements. Comfortable vehicles provide reliable city and highway travel suitable for business trips, tourism, and airport transfers. Professional chauffeurs ensure safe driving and punctual pickup services throughout the journey. Pickup services are available across Pune including homes, offices, hotels, railway stations, and airports. Flexible booking options allow hassle-free cab reservations."
  },
  {
    name: "Best Local Cab Pune",
    description: "Best local cab Pune service provides dependable transportation for daily city travel, office commutes, airport transfers, and sightseeing trips within Pune. Comfortable vehicles ensure smooth city travel with professional drivers offering safe and reliable transportation services. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Ideal for families, tourists, and business travelers. Flexible booking options allow convenient local cab reservations."
  },
  {
    name: "Pune Local Taxi and Outstation Service",
    description: "Pune local taxi and outstation service provides complete transportation solutions for city travel, airport transfers, and long-distance journeys from Pune. Comfortable vehicles ensure reliable city and highway travel suitable for business trips, tourism, family travel, and corporate transportation needs. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient local and outstation taxi reservations."
  }
],

tableData: [
  ["Pune Local and Outstation Cab", "Local Cab Pune"],
  ["Outstation Cab Pune", "City Taxi Pune"],
  ["Pune Day Rental Cab", "Hourly Cab Pune"],
  ["Pune Intercity Cab", "Local Sightseeing Cab Pune"],
  ["Outstation Travel Cab Pune", "Pune Cab Hire Local"],
  ["Pune Cab Hire Outstation", "Full Day Cab Pune"],
  ["Half Day Cab Pune", "Flexible Cab Booking Pune"],
  ["Best Local Cab Pune", "Pune Local Taxi and Outstation Service"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Local & Outstation Cab Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune local and outstation cab service for daily city travel, airport transfers, business meetings, family tours, and long-distance journeys with comfortable transportation solutions."
      },
      {
        WhyChooseheading: "Affordable Cab Service Pricing",
        WhyChoosedescription: "Shivai Travels offers affordable Pune local and outstation cab pricing with transparent fare details and no hidden charges for local rides and intercity travel bookings."
      },
      {
        WhyChooseheading: "24/7 Cab Service Availability",
        WhyChoosedescription: "Our Pune local and outstation cab service operates 24 hours a day for airport pickup, railway station transfers, office travel, emergency transportation, and weekend tours."
      },
      {
        WhyChooseheading: "Comfortable & Sanitized AC Vehicles",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, clean, sanitized, and regularly maintained to ensure safe and comfortable travel experiences for passengers."
      },
      {
        WhyChooseheading: "Flexible Local & Outstation Travel Options",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including local Pune sightseeing, one-way taxi service, round-trip outstation travel, airport transfers, and customized tour packages."
      },
      {
        WhyChooseheading: "Wide Range of Taxi Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, corporate travelers, and group trips."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, and Pimpri Chinchwad."
      },
      {
        WhyChooseheading: "Professional Drivers for Safe Travel",
        WhyChoosedescription: "Our experienced drivers provide punctual service, route expertise, smooth driving, and professional customer support for both local Pune travel and outstation journeys."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune local and outstation cab service?", answer: "Pune local and outstation cab service provides taxi transportation for city travel, airport transfers, and intercity journeys from Pune." },
    { question: "Is Pune local and outstation cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 local and outstation cab service in Pune." },
    { question: "Which vehicles are available for local and outstation travel?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book one-way and round-trip taxis?", answer: "Yes, customers can book one-way as well as round-trip taxi services from Pune." },
    { question: "Do you provide Pune Airport taxi service?", answer: "Yes, Shivai Travels provides airport pickup and drop services in Pune." },
    { question: "Are all taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable travel." },
    { question: "Can I book Pune local and outstation cabs online?", answer: "Yes, customers can easily book local and outstation cab services online or through phone booking." },
    { question: "Do you provide taxis for family tours and group travel?", answer: "Yes, Shivai Travels provides comfortable vehicles for family vacations, corporate travel, and group tours." },
    { question: "Are taxi fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for local and outstation travel?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak travel seasons." }
  ];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Deshmukh",
    feedback:
      "Shivai Travels offers both local and outstation cab service in Pune with excellent reliability, clean vehicles, and professional drivers ensuring a smooth travel experience.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Kulkarni",
    feedback:
      "The Pune local and outstation cab service was very convenient for both short city rides and long trips, with punctual service and comfortable travel throughout.",
    rating: 5
  }
];









































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Local and Outstation Cab",
  "image": "https://shivaitravels.com/assets/images/pune-local-outstation-cab.jpg",
  "description": "Book Pune local and outstation cab service for flexible travel needs including hourly rentals, full day and half day packages, city rides, sightseeing, and intercity travel. Shivai Travels offers affordable sedan, SUV, and AC cab options with 24x7 availability.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-local-and-outstation-cab"
  }
};




  return (
    <div>


<Helmet>
  <title>Pune Local and Outstation Cab | Flexible City & Travel Taxi Service | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune local and outstation cab service for city travel, hourly rental, sightseeing, full day and half day packages. Affordable and reliable sedan, SUV, and AC cab service available 24x7."
  />

  <meta
    name="keywords"
    content="Pune local and outstation cab, local cab pune, outstation cab pune, city taxi pune, pune day rental cab, hourly cab pune, pune intercity cab, local sightseeing cab pune, outstation travel cab pune, pune cab hire local, pune cab hire outstation, full day cab pune, half day cab pune, flexible cab booking pune, best local cab pune, Pune Local and Outstation Cab, Local and Outstation Cab Service Pune, Pune Cab Service for Local and Outstation, Best Local and Outstation Cab Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/12.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punelocalandouutstationcab;